<template>
  <div class="copyRightContainer">
      <a class="imgContent" href="https://zzlz.gsxt.gov.cn/businessCheck/verifKey.do?showType=p&serial=91150429MA0Q7JY31E-SAIC_SHOW_10000091150429MA0Q7JY31E1657775657694&signData=MEUCIQDdkl/+WH6YEGSVEyvi/E0fm1AnXBX3lsbQmLbk0J+WHwIgacnrsPbybSM2nWxGaKaFCnDGE3P0lXfvmzxfvQe+eh8=">
          <img src="../assets/images/lz4.png" alt="" srcset="">
      </a>
      <a href="http://beian.miit.gov.cn">Copyright蒙ICP备19002638号</a>
  </div>
</template>

<script>
export default {

}
</script>

<style scoped lang="scss">
.copyRightContainer{
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background: rgba($color: #000000, $alpha: 0.8);
    height: 48px;
    line-height: 48px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: row;
    a{
        color: #939393;
    }
    .imgContent{
        display: inline-block;
        height: 24px;
        width: 24px;
        margin-right: 10px;
        img{
            display: block;
            width: 100%;
            height: 100%;
        }
    }
}
</style>